import React, { useEffect, useState } from "react";
import { getDeviceSize } from "../../exports/InteractiveUtils";
import Pulse from "../Loader/Pulse";
import { COLOR_VARS } from "../../exports/ColorVars";
import { ArrowLeft2, ArrowRight2, Cross, OrderBook } from "../CustomComponents/SwiftIcon/Icons";
import CustomSelect from "../Body/CustomChartComponents/CustomSelect/CustomSelect";
import CustomCheckBox from "../Body/CustomChartComponents/CustomCheckBox/CustomCheckBox";
import CustomIconButton from "../Body/CustomChartComponents/CustomIconButton/CustomIconButton";
import ServerRequest from "../../exports/ServerRequest";
import { isAfterSevenDays, priceFormat } from "../../exports/UtilFunctions";
import ConfirmationBox, { ConfirmationBoxSmart } from "./ConfirmationBox";
import ConfirmationTable from "./ConfirmationTable";

const ceaseReasons = [
    { code: "01", label: "Non availability of Funds" },
    { code: "02", label: "Scheme not performing" },
    { code: "03", label: "Service issue" },
    { code: "04", label: "Load Revised" },
    { code: "05", label: "Wish to invest in other schemes" },
    { code: "06", label: "Change in Fund Manager" },
    { code: "07", label: "Goal Achieved" },
    { code: "08", label: "Not comfortable with market volatility" },
    { code: "09", label: "Will be restarting SIP after few months" },
    { code: "10", label: "Modifications in bank/mandate/date etc" },
    { code: "11", label: "I have decided to invest elsewhere" },
    { code: "12", label: "This is not the right time to invest" },
];

const DEVICE_SIZE = getDeviceSize();

const SipCease = ({ popupData, resetPopup, clientData }) => {
    const [loading, setLoading] = useState(false);
    const [transaction, setTransaction] = useState([]);
    const [loadingMsg, setLoadingMsg] = useState("Fetching your order");
    const [opacityMsg, setOpacityMsg] = useState(true);
    const [confirmloading, setConfirmLoading] = useState(false);
    const [confirmationMessage, setConfirmmationMessage] = useState('Placing your order')
    const [currentStep, setCurrentStep] = useState("Process");
    const [confirmMessage, setConfirmMessage] = useState('')
    const [purchaseMessage, setPurchaseMessage] = useState('')
    const [successData, setSuccessData] = useState([]);
    const [failedData, setFailedData] = useState([]);

    useEffect(() => {
        if (!popupData) return
        setLoading(true)
        setTransaction(popupData.filter((sip) => sip.Status === "Active"));
        setLoading(false)
    }, [popupData])

    useEffect(() => {
        console.log("transaction", transaction)
    }, [transaction])

    const handleSubmit = async () => {
        setConfirmLoading(true);
        const res = await ServerRequest({ url: '/mf/orderreferenceno', method: "get" });
        const ceaseSipOrderRefNumber = res.data;
        try {
            const newTransaction = transaction.filter((item) => item.toBeCeased)
            const res2 = await ServerRequest({
                url: '/nse/xsip-stop',
                method: 'post',
                data: {
                    transactions: newTransaction,
                    clientData: clientData,
                    ceaseSipOrderRefNumber: ceaseSipOrderRefNumber
                }
            });
            console.log("Stop Sip response", res2)
            const cancelDataArray = res2?.response?.can_data || [];

            if (cancelDataArray.length > 0) {
                const messages = cancelDataArray.map((d) => d.can_remark || "No remark");
                const success = cancelDataArray.filter(r => r.can_status === "CAN_SUCCESS");
                const fail = cancelDataArray.filter(r => r.can_status === "CAN_FAILED");

                setSuccessData(success);
                setFailedData(fail);

                setCurrentStep("Confirmation")
                if (success > 0) {
                    setPurchaseMessage("Please check your email for authorisation ")
                } else {
                    setPurchaseMessage(messages)
                }
            } else {
                setCurrentStep("Confirmation")
                setConfirmMessage("CFailed")
                setPurchaseMessage("Unexpected response from server.")
            }
        } catch (e) {
            console.error("Error in submitting cancle sip data", e);
        } finally {
            setConfirmLoading(false);
        }
    }

    return (
        <>
            {loading || confirmloading ? (
                <div className="app__login__screen">
                    <div className="app__login__process">
                        <Pulse />
                        {/* <p className={opacityMsg ? 'fadeIn' : 'fadeOut'}>{confirmloading ? confirmationMessage : loadingMsg}</p> */}
                    </div>
                </div>
            ) : (
                <>
                    <div className="swift-mf-popup-header">
                        <div className="swift-mf-popup-header-title">Stop SIP</div>
                    </div>
                    <div className="swift-mf-popup-text">Note: SIPs can only be stopped after 7 days</div>

                    <div className="swift-mf-popup-body">
                        <div className={`mf-BuySell-container ${currentStep === "Confirmation" ? "Confirmation" : ""}`}>
                            {currentStep === "Process" && (
                                <>
                                    {DEVICE_SIZE === "S" ? (
                                        <>
                                            {transaction.map((h, index) => (
                                                <SipCeaseCard data={h} index={index} setTransaction={setTransaction} />
                                            ))}

                                        </>
                                    ) : (
                                        <>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <td className="scheme-name">Scheme Name</td>
                                                        <td className="isin">ISIN</td>
                                                        <td className="isin">Folio</td>
                                                        <td className="isin">Day of Month</td>
                                                        <td className="isin">Completed Installments</td>
                                                        <td className="isin">Amount</td>
                                                        <td className="isin">Status</td>
                                                        <td className="scheme-name">Reason</td>
                                                        <td className="cross"></td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {transaction.map((h, index) => (
                                                        <tr key={index}>
                                                            <td>{h.SchemeName}</td>
                                                            <td>{h.ISIN}</td>
                                                            <td>{h.FolioNumber}</td>
                                                            <td>{h.DayOfMonth}</td>
                                                            <td>{h.Completed}</td>
                                                            <td>{h.Amount}</td>
                                                            <td>{h.Status}</td>
                                                            <td className='custom-text-td'>
                                                                <div className='cease-custom-select-container' >
                                                                    <CustomSelect
                                                                        value={h.code}
                                                                        defaultIndex={
                                                                            h.code
                                                                                ? ceaseReasons.findIndex((opt) => opt.code === h.code)
                                                                                : -1
                                                                        }
                                                                        options={ceaseReasons.map(opt => opt.label)}
                                                                        width={180}
                                                                        height={50}
                                                                        placeholder="-"
                                                                        disabled={!isAfterSevenDays(h.transaction_date)}
                                                                        onTypeChange={(selectedLabel) => {
                                                                            const matched = ceaseReasons.find(opt => opt.label === selectedLabel);
                                                                            setTransaction((prev) =>
                                                                                prev.map((item, i) =>
                                                                                    i === index ? { ...item, code: matched.code } : item
                                                                                )
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>{
                                                                <CustomCheckBox
                                                                    width={20}
                                                                    height={20}
                                                                    isChecked={h.toBeCeased || false}
                                                                    disabled={!isAfterSevenDays(h.transaction_date)}
                                                                    onChangeValue={(checked) => {
                                                                        setTransaction((prev) =>
                                                                            prev.map((item, i) =>
                                                                                i === index ? { ...item, toBeCeased: checked } : item
                                                                            )
                                                                        );
                                                                    }}
                                                                />
                                                            }</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </>
                                    )}
                                </>
                            )}
                            {currentStep === "Confirmation" && (
                                <>
                                    {(successData.length > 0 || failedData.length > 0) ? (
                                        <ConfirmationTable successData={successData} failedData={failedData} transferData={transaction} showMsg={false} />
                                    ) : (
                                        <ConfirmationBox
                                            msg={confirmMessage === "CFailed"
                                                ? "Looks like your transaction/order has failed."
                                                : "Your order has been successfully confirmed"}
                                            addMsg={purchaseMessage}
                                            confirmationType={confirmMessage}
                                        />
                                    )}
                                </>
                            )}
                        </div>
                        <div className="step-button mf-swift-buysell-confirm-button">
                            {currentStep === "Process" &&
                                <>
                                    <CustomIconButton title={`Back`}
                                        onClick={resetPopup}
                                        icon={<ArrowLeft2 size={20} color={COLOR_VARS.SWIFT_COLOR6} />} />
                                    <CustomIconButton
                                        title="Submit"
                                        onClick={handleSubmit}
                                        disabled={!transaction.some(item => item.toBeCeased && item.code)}
                                        icon={null}
                                    />

                                </>}
                            {currentStep === "Confirmation" &&
                                <>
                                    <CustomIconButton title={`Close`} onClick={resetPopup} icon={<Cross size={20} color={COLOR_VARS.SWIFT_COLOR6} />} />
                                </>}
                        </div>
                    </div>

                </>
            )}
        </>
    );
};

export default SipCease;

function SipCeaseCard({ data, index, setTransaction }) {
    const {
        ISIN,
        SchemeName,
        FolioNumber,
        DayOfMonth,
        Completed,
        Amount,
        Status,
        code,
        toBeCeased,
        transaction_date,
    } = data;

    return (
        <div className="mf-watchlist-card">
            {/* Header */}
            <div className="mfwc-info">
                <div className="isin-price">
                    <p className="isin-type">
                        ISIN | <span>{ISIN}</span>
                    </p>
                    {/* <p className="isin-type right-top-txt">{Status.toUpperCase()}</p> */}
                    <p className="isin-type right-top-txt"><CustomCheckBox
                        width={20}
                        height={20}
                        isChecked={toBeCeased || false}
                        disabled={!isAfterSevenDays(transaction_date)}
                        onChangeValue={(checked) => {
                            setTransaction((prev) =>
                                prev.map((item, i) =>
                                    i === index ? { ...item, toBeCeased: checked } : item
                                )
                            );
                        }}
                    /></p>
                </div>
                <p className="name">{SchemeName}</p>
            </div>

            {/* Body details */}
            <div className="mfwc-config">
                <div className="mfwc-config-row">
                    <p>
                        Folio <span>{FolioNumber}</span>
                    </p>
                    <p>
                        Day <span>{DayOfMonth}</span>
                    </p>
                </div>
                <div className="mfwc-config-row">
                    <p>
                        Completed Installments <span>{Completed}</span>
                    </p>
                    <p>
                        Amount <span>{priceFormat(Amount)}</span>
                    </p>
                </div>
                <div className="mfwc-config-row">
                    <p>Reason
                        <div className='cease-custom-select-container ' >
                            <CustomSelect
                                value={code}
                                defaultIndex={code ? ceaseReasons.findIndex((opt) => opt.code === code) : -1}
                                options={ceaseReasons.map((opt) => opt.label)}
                                width={180}
                                height={50}
                                placeholder="-"
                                disabled={!isAfterSevenDays(transaction_date)}
                                onTypeChange={(selectedLabel) => {
                                    const matched = ceaseReasons.find((opt) => opt.label === selectedLabel);
                                    setTransaction((prev) =>
                                        prev.map((item, i) =>
                                            i === index ? { ...item, code: matched.code } : item
                                        )
                                    );
                                }}
                            />
                        </div></p>
                </div>

            </div>
        </div>
    );
}
